const DIFMACD = [
    {id: "0", value: "DIF"},    
    {id: "1", value: "MACD"},
    {id: "2", value: "OSC"},    
  ];  
  
  export default DIFMACD